import { useState, useEffect } from 'react';

export default function useDetectWidth() {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    // Clean up event listener when component unmounts
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {screenWidth};
}